module.exports = __webpack_public_path__ + "img/SKMJ.f38a18ad.svg";